import { render, staticRenderFns } from "./ListaIncidencia.vue?vue&type=template&id=1194b4ec&scoped=true"
import script from "./ListaIncidencia.vue?vue&type=script&lang=js"
export * from "./ListaIncidencia.vue?vue&type=script&lang=js"
import style0 from "./ListaIncidencia.vue?vue&type=style&index=0&id=1194b4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194b4ec",
  null
  
)

export default component.exports